import { render, staticRenderFns } from "./FakePayoutForm.vue?vue&type=template&id=4e19790c&"
import script from "./FakePayoutForm.vue?vue&type=script&lang=js&"
export * from "./FakePayoutForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports